module.exports = __webpack_public_path__ + "img/select-dropdown.3412c006.svg";